module.exports = __webpack_public_path__ + "img/Zsuzsi_Simon_Alexandru_06.1e7afd9a.jpg";